export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtPPNRVolna';
export const NAME = 'PracovniPozice';
export const COLUMN_ISEXTERNAL = 'IS_EXTERNAL';

export const PP_TYPES = {
	DEFAULT: 0,
	VOLNA_STRINGS: 1,
	SDA_SQL: 1,
	NEKONC_120: 3,
	SN: 4,
	VOLNA_BOOL: 5,
};

export enum PP_FILTER_ENUM {
	DEFAULT,
	SDA,
	SP,
	NEKONCERNOVE,
	VOLNE_NEKONCERNOVE
}

export const PP_WILDCARD_STRINGS = {
	SQL: '%',
	SNPP: '-',
	PPNR: '*',
	PPNR_VOLNA: '?',
	PPNR_120: '!',
};

export const PP_PREFIX_STRINGS = {
	PPNR_VOLNA1: '98',
	PPNR_VOLNA2: '99',
	PPNR_120: '00',
};

export const SET_LIST_TABLE_SCHEMA = 'SET_LIST_TABLE_SCHEMA';
